/*eslint-disable*/

export const SET_NAV_INDEX = 'SET_NAV_INDEX';

export const SET_MINE_NAV_INDEX = 'SET_MINE_NAV_INDEX';

export const SET_SLOTS_NAV_INDEX = 'SET_SLOTS_NAV_INDEX';

export const SET_MINE_CAPITAL_NAV = 'SET_MINE_CAPITAL_NAV';

export const SET_HELP_CAPITAL_NAV = 'SET_HELP_CAPITAL_NAV';

export const SET_USER_INFO = 'SET_USER_INFO';

export const CLOSE_INDEX_AD = 'CLOSE_INDEX_AD';

export const CHECK_LOGIN = 'CHECK_LOGIN';

export const LOGIN = 'LOGIN';

export const LOGIN_OUT = 'LOGIN_OUT';

export const INIT_LIST='INIT_LIST';

export const FRONTCONFIG_LIST='FRONTCONFIG_LIST';

// 维护列表
export const SET_MAINTAIN_GAME_LIST = 'SET_MAINTAIN_GAME_LIST';
// 维护信息
export const SET_MAINTAIN_GAME_INFO = 'SET_MAINTAIN_GAME_INFO';
// 维护弹框状态
export const SET_MAINTAIN_GAME_STATE = 'SET_MAINTAIN_GAME_STATE';
// 设置站内信条数
export const SET_INEMAIL = 'SET_INEMAIL';

// 各游戏平台
export const GAME_LIST_BY_PLATFORM = 'GAME_LIST_BY_PLATFORM';

// 一级导航
export const SET_FIRST_NAV = 'SET_FIRST_NAV';

// 老虎机游戏图片链接
export const SET_SLOT_PIC = 'SET_SLOT_PIC';
// 老虎机收藏
export const SET_SLOT_COLLECTION = 'SET_SLOT_COLLECTION';

// 多彩宝
export const ADD_COLOR_STARTMONEY = 'ADD_COLOR_STARTMONEY';

export const SET_COLOR_SERVICE = 'SET_COLOR_SERVICE';

// 金色
export const SET_ARTICLETYPELIST = 'SET_ARTICLETYPELIST';

// 金沙
// 进入游戏登陆框
export const JIN_SHA_GLOBAL_LOGIN = 'JIN_SHA_GLOBAL_LOGIN';
// 登录前选择的游戏
export const BEFORE_LOGIN_GAME_INFO = 'BEFORE_LOGIN_GAME_INFO';

export const IS_LOGIN_FOCUS = 'IS_LOGIN_FOCUS';

//体育
// 顶部导航颜色切换
export const SPORTS_SET_TOP_NAV = 'SPORTS_SET_TOP_NAV';
// 体育导航
export const SET_SPORTS_NAV_INDEX = 'SET_SPORTS_NAV_INDEX';
// 体育注册弹框
export const SET_IS_REGISTER_SUCCESS = 'SET_IS_REGISTER_SUCCESS'

// 设置新优惠type
export const SETBONUSTYPES = 'SETBONUSTYPES'




// WEBPACK FOOTER //
// ./src/common/store/mutation-types.js